module.exports = __webpack_public_path__ + "static/media/18ECA34.0f19c7d1.jpg";